module.exports = __webpack_public_path__ + "static/media/triobanner.a5046e51.png";